interface ArrowIconType {
  direction?: 'right' | 'left' | 'up' | 'down';
  size?: number;
  className?: string;
  strokeWidth?: number;
}

const ArrowIcon = ({
  direction = 'right',
  size = 20,
  className = '',
  strokeWidth = 2,
}: ArrowIconType) => {
  const getDirection = () => {
    switch (direction) {
      case 'right':
        return (
          <>
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </>
        );
      case 'left':
        return (
          <>
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </>
        );
      case 'up':
        return (
          <>
            <line x1="12" y1="19" x2="12" y2="5"></line>
            <polyline points="5 12 12 5 19 12"></polyline>
          </>
        );
      case 'down':
        return (
          <>
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <polyline points="19 12 12 19 5 12"></polyline>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      className={className}
    >
      {getDirection()}
    </svg>
  );
};

export default ArrowIcon;
